import type { SharedTypes } from '@semios/app-platform-banyan-route-definitions'
import { sortByKey } from 'utils/sortByKey'

type TExternalVendorNames = SharedTypes.IrrigationScheduler.EIrrigationVendorName[]

export const filterUniqueAndMapToValueAndLabel = <T>(args: {
  items: Array<T>
  filter?: (item: T) => boolean
  uniqueBy: (item: T) => string
  mapToLabel: (item: T) => string
  mapToExternalVendorNames?: (item: T) => TExternalVendorNames | undefined
}) => {
  return Object.entries(
    args.items.reduce<
      Record<string, { label: string; externalVendorNames: TExternalVendorNames | undefined }>
    >((acc, item) => {
      const k = args.uniqueBy(item)
      const filterCheck = args.filter ? args.filter(item) : true

      if (filterCheck && !acc[k]) {
        return {
          ...acc,
          [k]: { label: args.mapToLabel(item), externalVendorNames: args.mapToExternalVendorNames?.(item) },
        }
      } else {
        return acc
      }
    }, {}),
  )
    .map(([k, { label, externalVendorNames }]) => ({
      label,
      value: k,
      id: k,
      ...(externalVendorNames?.length ? { externalVendorNames } : {}),
    }))
    .sort(sortByKey('label'))
}
